import { z } from "zod/v4";

const LiveStatusSchema = z.object({
  indicator: z.enum(["none", "minor", "major", "critical"]),
  description: z.string(),
});

const LiveStatusPageSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.url(),
  time_zone: z.string(),
  updated_at: z.iso.datetime({ offset: true }),
});

const LiveStatusResponseSchema = z.object({
  page: LiveStatusPageSchema,
  status: LiveStatusSchema,
});

type LiveStatus = z.infer<typeof LiveStatusSchema>;
type LiveStatusResponse = z.infer<typeof LiveStatusResponseSchema>;

export { LiveStatusSchema, LiveStatusResponseSchema };
export type { LiveStatus, LiveStatusResponse };
